import React from 'react'
import { Routes, Route } from "react-router-dom";
import ListCA from '../componentes/view/acopios/centros/listca'; 
import ListaCaRep from '../componentes/view/acopios/recepcion/carep';
import Cxp from '../componentes/view/Planta/cxp';
import BusquedaEtiquetasV2 from '../componentes/view/Planta/cxp2';
import CXP3Page from '../componentes/view/Planta/cxp3';


export const CentroAcopioRoutes = () => {

    return (
      <Routes>
       
        <Route path="dashboards/ca" element={ <ListCA /> } />
        <Route path="lista/ca" element={ <ListaCaRep/> } />
        <Route path="CXP" element={ <Cxp/> } /> 
        <Route path="CXP2" element={ <BusquedaEtiquetasV2/> } />
        <Route path="CXP3" element={ <CXP3Page/> } />
      </Routes>
    )
  }
  